const ROUTES_ENUM = {
    BASE: "/",
    BASE_LEAD_REFERENCE:'/rid/:rid',
    BASE_CUSTOMER_REFERENCE: "/cid/:customerId",
    NOT_FOUND: "/not-found",
    TERMS_CONDITIONS: "/terms-and-conditions",
    LEAD_REGISTER: {
        BASE:"/lead-register",
        LEAD_REFERENCE: "/lead-register/rid/:rid",
        CUSTOMER_REFERENCE: "/lead-register/cid/:customerId"
    },
    DOWNLOAD_APP: '/download-mobile-app',
    CONFIRM_PHONE:"/confirm-phone-number"
};

export default ROUTES_ENUM;
